import Axios from 'axios';

interface Config {
  visualizouOnboarding?: boolean;
  visualizouAvisoBDQ?: boolean;
  visualizouAvisoLabVirtual?: boolean;
  visualizouAvisoBibliotecaVirtual?: boolean;
  visualizouAvisoEmpregabilidade?: boolean;
}

interface Params {
  urlBase: string;
  token: string;
  idEducador: string;
  config: Config;
}

export const configEducadorService = async ({
  urlBase,
  token,
  idEducador,
  config: {
    visualizouOnboarding,
    visualizouAvisoBDQ,
    visualizouAvisoLabVirtual,
    visualizouAvisoBibliotecaVirtual,
    visualizouAvisoEmpregabilidade,
  },
}: Params) => {
  const authorization = `Bearer ${token}`;
  await Axios.post(
    `${urlBase}/v2/educadores/${idEducador}/config`,
    {
      visualizouOnboarding,
      visualizouAvisoBDQ,
      visualizouAvisoLabVirtual,
      visualizouAvisoBibliotecaVirtual,
      visualizouAvisoEmpregabilidade,
    },
    { headers: { authorization } },
  );
};
